import { OsType } from 'shared/enums/os-type.enum';

/** OS types available in the platform filter (iOS and Android only). */
export type PlatformFilterOsType = OsType.Ios | OsType.Android;

/**
 * Desktop size variant for the PlatformFilter.
 */
export type PlatformFilterSize = 'big' | 'small';

/**
 * Props for the PlatformFilter dropdown component.
 */
export interface PlatformFilterProps {
  /** Currently selected OS type id (games.os_type_id). */
  value: PlatformFilterOsType;
  /** Callback fired when a different OS type is selected. */
  onChange: (osTypeId: PlatformFilterOsType) => void;
  /** Desktop size variant. */
  size?: PlatformFilterSize;
  /** Additional CSS classes for custom styling */
  className?: string;
  /** Unique identifier for the filter */
  id?: string;
}

export const GAMES_CARD_CHROME_DESKTOP_REST_CLASSES = 'md:border-[#DFDFE2] md:shadow-[2px_2px_0px_0px_#DFDFE2]';
export const GAMES_CARD_OUTLINED_BUTTON_MOBILE_CLASSES =
  'max-md:!border-[#DFDFE2] max-md:!shadow-[2px_2px_0px_0px_#DFDFE2] max-md:hover:!border-[#5b98d1] max-md:hover:!shadow-[2px_2px_0px_0px_#5b98d1] max-md:active:!border-[#3f54a4] max-md:active:!shadow-none';
export const GAMES_CARD_OUTLINED_BUTTON_DESKTOP_CLASSES =
  'md:!border-[#DFDFE2] md:!shadow-[2px_2px_0px_0px_#DFDFE2] md:hover:!border-[#5b98d1] md:hover:!shadow-[2px_2px_0px_0px_#5b98d1] md:active:!border-[#3f54a4] md:active:!shadow-none';
